import {filterArrayUndefined} from '@coolcolduk/util';
import type {SeedQuestion, SeedQuestionStatus} from '@cp/model';
import {getDocs, limit, orderBy, query, where, type QueryConstraint} from 'firebase/firestore';
import getSeedQuestionCollectionRef from './getSeedQuestionCollectionRef';
import mapSeedQuestionDoc from './mapSeedQuestionDoc';

export interface ListSeedQuestionsDocParams {
  moduleId: string;
  topic?: string;
  status?: SeedQuestionStatus;
  limit?: number;
  offset?: number;
}

export default async function listSeedQuestionsDoc(params: ListSeedQuestionsDocParams): Promise<SeedQuestion[]> {
  const {moduleId, topic, status, limit: take = 50, offset = 0} = params;
  const col = getSeedQuestionCollectionRef(moduleId);
  const constraints: QueryConstraint[] = [orderBy('createdAt', 'desc')];
  if (topic) {
    constraints.push(where('topic', '==', topic));
  }
  if (status) {
    constraints.push(where('status', '==', status));
  }
  const fetchSize = offset + take;
  constraints.push(limit(fetchSize));
  const snapshot = await getDocs(query(col, ...constraints));
  const mapped = filterArrayUndefined(snapshot.docs.map((d) => mapSeedQuestionDoc(d)));
  return mapped.slice(offset, offset + take);
}
